import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from 'common/constants'
import { Map } from 'immutable'
import { SHOW_ERRORS_APP_CALL } from 'store/app/actions'

import { AreaActionTypes } from './action.model'
import {
  CLEANUP_AREA,
  CLEAR_AREA_ITEM_ERRORS,
  CREATE_AREA_REQUEST,
  DELETE_AREA_BY_ID_FAILURE,
  DELETE_AREA_BY_ID_REQUEST,
  DELETE_AREA_BY_ID_SUCCESS,
  EXPORT_AREA_FAILURE,
  EXPORT_AREA_REQUEST,
  EXPORT_AREA_SUCCESS,
  FETCH_AREA_BY_BIID_REQUEST,
  FETCH_AREA_BY_BIID_SUCCESS,
  FETCH_AREA_REQUEST,
  FETCH_AREA_SUCCESS,
  FETCH_AREAS_FAILURE,
  FETCH_AREAS_REQUEST,
  FETCH_AREAS_REQUEST_AUTH,
  FETCH_AREAS_SUCCESS,
  HANDLE_SUBMIT_AREA_FAILURE,
  IMPORT_AREA_FAILURE,
  IMPORT_AREA_REQUEST,
  IMPORT_AREA_SUCCESS,
  INSERT_AREA_REQUEST,
  PARTIAL_CLEANUP_AREA,
  SUBMIT_AREA_FAILURE,
  SUBMIT_AREA_SUCCESS,
  UPDATE_AREA_REQUEST,
} from './constant'

export const initialState = Map({
  list: Map({
    data: [],
    loading: false,
    filters: null,
    sort: ['-code'],
    pageNumber: DEFAULT_PAGE_NUMBER,
    pageSize: DEFAULT_PAGE_SIZE,
    totalRecords: 0,
  }),
  item: Map({
    data: null,
    loading: false,
    errors: null,
  }),
  import: Map({
    loading: false,
    error: {
      message: '',
      details: [],
    },
  }),
  export: {
    loading: false,
  },
})

export default (state = initialState, action: AreaActionTypes): any => {
  switch (action.type) {
    case FETCH_AREAS_REQUEST:
    case FETCH_AREAS_REQUEST_AUTH:
      return state
        .setIn(['list', 'loading'], true)
        .setIn(['list', 'pageNumber'], action.payload.pageNumber)
        .setIn(['list', 'pageSize'], action.payload.pageSize)
        .setIn(['list', 'filters'], action.payload.filters)
        .setIn(['list', 'sort'], action.payload.sort)
    case FETCH_AREAS_SUCCESS:
      return state
        .setIn(['list', 'loading'], false)
        .setIn(['list', 'data'], action.payload.data)
        .setIn(['list', 'totalRecords'], action.payload.totalRecords)
    case FETCH_AREAS_FAILURE:
      return state.setIn(['list', 'loading'], false).setIn(['list', 'data'], []).setIn(['list', 'totalRecords'], 0)
    case FETCH_AREA_REQUEST:
    case DELETE_AREA_BY_ID_REQUEST:
      return state.setIn(['item', 'loading'], true)
    case FETCH_AREA_SUCCESS:
      return state.setIn(['item', 'loading'], false).setIn(['item', 'data'], action.payload)
    case FETCH_AREA_BY_BIID_REQUEST:
      return state.setIn(['item', 'loading'], true)
    case FETCH_AREA_BY_BIID_SUCCESS:
      return state.setIn(['item', 'loading'], false).setIn(['item', 'data'], action.payload)
    case CREATE_AREA_REQUEST:
    case INSERT_AREA_REQUEST:
    case UPDATE_AREA_REQUEST:
      return state.setIn(['item', 'loading'], true)
    case SUBMIT_AREA_FAILURE:
      return state.setIn(['item', 'loading'], false).setIn(['item', 'errors'], action.payload)
    case SUBMIT_AREA_SUCCESS:
      return state.setIn(['item', 'loading'], false).setIn(['item', 'errors'], null)
    case HANDLE_SUBMIT_AREA_FAILURE:
      return state.setIn(['item', 'loading'], false).setIn(['item', 'errors'], action?.error)
    case DELETE_AREA_BY_ID_SUCCESS:
    case DELETE_AREA_BY_ID_FAILURE:
      return state.setIn(['item', 'loading'], false)
    case CLEAR_AREA_ITEM_ERRORS:
      return state.setIn(['item', 'errors'], null)
    case IMPORT_AREA_REQUEST:
      return state.setIn(['import', 'loading'], true)
    case IMPORT_AREA_SUCCESS:
      return state
        .setIn(['import', 'loading'], false)
        .setIn(['import', 'error'], initialState.getIn(['import', 'error']))
    case IMPORT_AREA_FAILURE:
      return state.setIn(['import', 'loading'], false).setIn(['import', 'error'], action.payload)
    case EXPORT_AREA_REQUEST:
      return state.setIn(['list', 'loading'], true)
    case EXPORT_AREA_SUCCESS:
    case EXPORT_AREA_FAILURE:
      return state.setIn(['list', 'loading'], false)
    case SHOW_ERRORS_APP_CALL:
      return state.setIn(['item', 'loading'], false)
    case PARTIAL_CLEANUP_AREA:
      return initialState.setIn(['list'], state.getIn(['list']))
    case CLEANUP_AREA:
      return initialState
    default:
      return state
  }
}
